/* eslint-disable import/no-internal-modules */
import {
  ContentType,
  isProductUpdate,
  isArticle,
  isConversation,
  isQuestion,
  getConsistentContentType
} from '@insided/shared/utils/contentType'
import { Component } from 'preact'
import htmlParser from '@insided/deprecated-preact-components/utils/htmlParser'
import { excerpt } from '@insided/deprecated-preact-components/utils/string'
import { pascalToKebab } from '@insided/deprecated-preact-components/utils/toKebabCase'

export interface PostCellProps {
  topicId: string
  contentType: ContentType
  title: string
  content: string
  replyId: string
}

interface State {
  showMore: boolean
}

class PostCell extends Component<PostCellProps, State> {
  state = {
    showMore: false
  }

  render() {
    const { topicId, contentType, title, content, replyId } = this.props
    const { showMore } = this.state

    const strippedContent = htmlParser.stripHtml(content) || ''
    const excerptLimit = 200 // characters

    const consistentContentType = getConsistentContentType(contentType)

    const urlContentType = isProductUpdate(consistentContentType)
      ? pascalToKebab(consistentContentType)
      : `${consistentContentType}s`

    const titleUrl =
      replyId &&
      (isArticle(consistentContentType) || isQuestion(consistentContentType) || isConversation(consistentContentType))
        ? `/${urlContentType}/${topicId}/replies/${replyId}`
        : `/${urlContentType}/${topicId}`

    return (
      <div className='overview__spam-post'>
        <a className='bold' href={titleUrl}>
          {replyId && 'RE: '}
          {title}
        </a>
        <div className='overview__spam-post-content'>
          <span>{showMore ? strippedContent : excerpt(strippedContent, excerptLimit)}</span>
          {strippedContent.length > excerptLimit && (
            <a onClick={() => this.setState({ showMore: !showMore })}>Show {showMore ? 'less' : 'more'}</a>
          )}
        </div>
      </div>
    )
  }
}

export default PostCell
